module.exports = __webpack_public_path__ + "static/media/profile-picture1.bd53f429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile-picture1.jpg
// module id = 80
// module chunks = 0